<template>
    <!-- TODO: "ml-5" can be deleted as soon as we have the ActionsDropdown on this page! -->
    <v-row>
        <ActionDropdown 
            :items="actions"
            context="Invoices"
            alvqa="erp-invoices"
        /> 
        <ReportButton                 
                :items="reportOptions"
                context="FileReport"
                :alvqa="alvqa"
                cols="2"
            />
         <v-col 
            cols="4"
            v-if="totalRecords !== null"
            align-self="center"
            class="v-label theme--light mt-3"
        >
            <BaseHeaderStats context="Invoices" typeStats="LIST" alvqa="erp-invoices-list" />
         </v-col>
        <v-spacer />
        <v-col 
            xl="2"
            lg="3"
            align-self="end"
        >
            <BaseButton 
                label="lang_ERP_INVOICES_BUTTON_CAPTION_ADD_NEW_INVOICE"
                :to="{ name: editForm, params: { alvId: 'new' } }"
                block
                color="buttonNewEntity"
                :alvqa="alvqa + '-list-button-new'"
            />
        </v-col>
    </v-row>    
</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ReportButton from '@/components/_buttons/ReportButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'

export default {
    name: "InvoicesTopSlot",
    data() {
        return {
            editForm: "InvoicesEdit",
            alvqa: "erp-invoices"
        }
    },
    components: {
        BaseHeaderStats,
        BaseButton,
        ReportButton,
        ActionDropdown
    },
    computed:{
        totalRecords() { return this.$store.getters.getTotalRecords },
        
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_PRINT'), 
                    value: 'print',
                    alvqa: this.alvqa + '-list-action-dropdown-print'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'export',
                    alvqa: this.alvqa + '-list-action-dropdown-export'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_COPY'), 
                    value: 'copy', 
                    alvqa: this.alvqa + '-list-action-dropdown-copy'
                },
                {
                    text: this.$t('lang_ERP_INVOICES_ACTION_CREATE_ACCOUNT_STATEMENT'), 
                    value: 'createAccountStatement', 
                    alvqa: this.alvqa + '-list-action-dropdown-create-account-statement'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        },
        reportOptions(){
            let allOptions = [
                {
                    text: this.$t('lang_ERP_INVOICES_CAPTION_ACCOUNT_OVERVIEW'), 
                    value: 'accountReviewErpInvoices', 
                    alvqa: this.alvqa + '-list-report-dropdown-account-overview'
                },
                {
                    text: this.$t('lang_ERP_INVOICES_REPORT_DROPDOWN_GEMA_AUDIT_REPORT'), 
                    value: 'gemaAuditReportErpInvoices', 
                    alvqa: this.alvqa + '-list-report-dropdown-gema-audit'
                },
            ]

            return allOptions
        }
    },
    methods: {
        accountOverview() {
            this.$store.dispatch('invoicesAccountOverview')
        }
    }
}
</script>